module.exports = __webpack_public_path__ + "img/Logo.b200c39a.svg";